import { Directive, Input, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[dfControlId]'
})
export class ControlIdDirective {
  @Input() isDesign: boolean;

  @Input('dfControlId')
  set id(id: string) {
    this._id = id;
    this.setIdAttribute();
  }
  get id(): string {
    return this._id;
  }

  private _id: string;

  constructor(private elementRef: ElementRef, private renderer2: Renderer2) {}

  private setIdAttribute() {
    if (!this.elementRef.nativeElement) {
      return;
    }

    if (!this.id) {
      this.renderer2.removeAttribute(this.elementRef.nativeElement, 'id');
      return;
    }

    let id = '';
    if (!this.isDesign) {
      id = this.id;
    } else {
      id = 'design' + this.id;
    }
    this.renderer2.setAttribute(this.elementRef.nativeElement, 'id', id);
  }
}
